import React, { useEffect, useState, useRef } from "react";
// import { Domain } from "Domain";
import Table from "components/Table/Table1.js";
// import autoTable from "jspdf-autotable";
// core components
// import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
// import axios from "axios";
// import Danger from "components/Typography/Danger";
// import ImageUpload from "components/CustomUpload/ImageUpload.js";
import "jspdf-autotable";
// import EmptyTable from "components/EmptyTable";
import { saveAs } from "file-saver";
import XlsxPopulate from "xlsx-populate";
import ReactToPrint from "react-to-print";
// import DataTable from "components/Table/DataTable";
// import CustomFileInput from "components/CustomFileInput/CustomFileInput";
// import { AttachFile } from "@material-ui/icons";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import TextField from "@mui/material/TextField";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// Temporarily disabled with the Doctors TDS Data card below.
// import Events2 from "views/Events/Events2";
import Events1 from "views/Events/Events1";
import Events from "views/Events/Events";
// import Invoice from "components/reports/Invoice";
// import { PDFViewer } from "@react-pdf/renderer";
import CustomInput from "components/CustomInput/CustomInput";
// import Danger from "components/Typography/Danger";
// import { Link } from "react-router-dom";
import LogoHeader from "assets/img/header.png";
import Signature from "assets/img/Signature.png";
import { Box, Button as MuiButton, Paper, Typography } from "@mui/material";
import {
  ArrowLeft,
  DownloadSimple,
  FilePdf,
  Receipt,
  UploadSimple,
  UsersThree,
} from "@phosphor-icons/react";
// import axios from "axios";
// import { Domain } from "Domain";

const IMPORT_FIELD_ALIASES = {
  Client: [
    "client",
    "diagnostic center",
    "diagnostic centre",
    "diagnostic center name",
    "hospital",
    "facility",
  ],
  Name: ["patient name", "patient", "name", "patientname"],
  Modality: ["modality", "modality name", "scan type", "study type"],
  BodyPart: [
    "body part",
    "bodypart",
    "study tags",
    "study tags",
    "body region",
    "anatomy",
  ],
  Doctor: [
    "assigned radiologists",
    "assigned radiologist",
    "radiologist",
    "doctor",
    "doctor name",
    "reporting doctor",
  ],
  ReportedTime: [
    "reported time",
    "reported",
    "reporting time",
    "study uploaded time",
    "study uploaded",
    "uploaded time",
    "uploaded",
  ],
  DispatchedTime: [
    "dispatched time",
    "dispatched",
    "report finalized time",
    "report finalized",
    "finalized time",
    "finalized",
  ],
  Status: ["case status", "status", "case state", "state"],
};

function normalizeImportHeader(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

const NORMALIZED_IMPORT_ALIASES = Object.fromEntries(
  Object.entries(IMPORT_FIELD_ALIASES).map(([field, aliases]) => [
    field,
    aliases.map(normalizeImportHeader),
  ])
);

function getImportValue(row, field) {
  const valuesByHeader = Object.keys(row).reduce((values, header) => {
    values[normalizeImportHeader(header)] = row[header];
    return values;
  }, {});

  const matchingHeader = NORMALIZED_IMPORT_ALIASES[field].find(
    (alias) => valuesByHeader[alias] !== undefined
  );
  return matchingHeader ? valuesByHeader[matchingHeader] : "";
}

function padImportDatePart(value) {
  return String(value).padStart(2, "0");
}

function formatImportDateTime(value) {
  if (value === null || value === undefined || value === "") return "";

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return `${value.getFullYear()}-${padImportDatePart(
      value.getMonth() + 1
    )}-${padImportDatePart(value.getDate())} ${padImportDatePart(
      value.getHours()
    )}:${padImportDatePart(value.getMinutes())}:${padImportDatePart(
      value.getSeconds()
    )}`;
  }

  if (typeof value === "number") {
    const parsed = XLSX.SSF.parse_date_code(value);
    if (parsed) {
      if (!parsed.d) {
        return `${padImportDatePart(parsed.H || 0)}:${padImportDatePart(
          parsed.M || 0
        )}:${padImportDatePart(parsed.S || 0)}`;
      }
      return `${parsed.y}-${padImportDatePart(parsed.m)}-${padImportDatePart(
        parsed.d
      )} ${padImportDatePart(parsed.H || 0)}:${padImportDatePart(
        parsed.M || 0
      )}:${padImportDatePart(parsed.S || 0)}`;
    }
  }

  const text = String(value).trim().replace("T", " ");
  const timeMatch = text.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(am|pm)?/i);
  let hours = timeMatch ? Number(timeMatch[1]) : 0;
  const minutes = timeMatch ? Number(timeMatch[2]) : 0;
  const seconds = timeMatch ? Number(timeMatch[3] || 0) : 0;
  const meridiem = timeMatch?.[4]?.toLowerCase();
  if (meridiem === "pm" && hours < 12) hours += 12;
  if (meridiem === "am" && hours === 12) hours = 0;

  const dateText = (timeMatch ? text.slice(0, timeMatch.index) : text)
    .trim()
    .replace(/[/.]/g, "-");
  const isoDate = dateText.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  const regionalDate = dateText.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
  let year;
  let month;
  let day;
  if (isoDate) {
    [, year, month, day] = isoDate;
  } else if (regionalDate) {
    [, day, month, year] = regionalDate;
    if (Number(day) <= 12 && Number(month) > 12) {
      [day, month] = [month, day];
    }
  }

  if (year) {
    return `${year}-${padImportDatePart(month)}-${padImportDatePart(
      day
    )} ${padImportDatePart(hours)}:${padImportDatePart(
      minutes
    )}:${padImportDatePart(seconds)}`;
  }

  return timeMatch
    ? `${dateText} ${padImportDatePart(hours)}:${padImportDatePart(
        minutes
      )}:${padImportDatePart(seconds)}`.trim()
    : text;
}

function getImportHour(value) {
  const timeMatch = String(value ?? "").match(
    /(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(am|pm)?/i
  );
  if (!timeMatch) return -1;

  let hour = Number(timeMatch[1]);
  const meridiem = timeMatch[4]?.toLowerCase();
  if (meridiem === "pm" && hour < 12) hour += 12;
  if (meridiem === "am" && hour === 12) hour = 0;
  return hour;
}

function normalizeWorklogValue(value) {
  return String(value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();
}

function getUniqueRows(rows, keyGetter) {
  const seen = new Set();
  return rows.filter((row) => {
    const key = keyGetter(row);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function getStudyKey(row) {
  return [
    row.Client,
    row.Name,
    row.Modality,
    row.BodyPart,
    row.Doctor,
    row.ReportedTime,
    row.DispatchedTime,
  ]
    .map(normalizeWorklogValue)
    .join("|");
}

export default function WorkLog() {
  let componentRef = useRef();
  let componentRef2 = useRef();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const [saved, setSaved] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [AddStaff, setAddStaff] = useState(false);

  const [Doctors, setDoctor] = useState("");
  const [Clients, setClient] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);
  const [Open, setOpen] = useState(false);
  const [ClientsList, setClientsList] = useState([]);
  const [DoctorsList, setDoctorsList] = useState([]);
  const [JsonDataToInsert, setJsonDataToInsert] = useState([]);
  const [UpdatedData, setUpdatedData] = useState();
  const [Error, setError] = useState(false);
  const [Clientloaded, setLoadedClient] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [Total, setTotal] = useState(0);
  const [DocTotal, setDocTotal] = useState(0);
  const [InvoiceOpen, setInvoiceOpen] = useState(false);
  // const [ClickGenerate, setClickGenerate] = useState(false);

  // const [Pan, SetDocPan] = useState("");
  //Generate Price Function
  //console.log("UpdatedDAta:++++++++++", UpdatedData);
  function getSheetData(data, header) {
    var fields = Object.keys(data[0]);
    var sheetData = data.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : "";
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }

  async function saveAsExcel() {
    if (UpdatedData) {
      setError(false);
      let header = [
        "Sl.No",
        "Patient Name",
        "Client",
        "Modality",
        "Body Part",
        "Reported Time",
        "Day/Night",
        "Price",
      ];

      XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const sheet1 = workbook.sheet(0);

        const sheetData = getSheetData(UpdatedData, header);

        const totalColumns = sheetData[0].length;

        sheet1.cell("A1").value(sheetData);
        sheet1.column("A").width(10);
        sheet1.column("B").width(25);
        sheet1.column("C").width(25);
        sheet1.column("D").width(25);
        sheet1.column("E").width(25);
        sheet1.column("F").width(25);
        sheet1.column("G").width(25);
        const range = sheet1.usedRange();
        const endColumn = String.fromCharCode(64 + totalColumns);
        sheet1.row(1).style("bold", true);
        sheet1.range("A1:" + endColumn + "1").style("fill", "d3d3d3");
        range.style("border", false);
        return workbook.outputAsync().then((res) => {
          saveAs(res, Doctors + "_invoice.xlsx");
        });
      });
    } else {
      setError(true);
    }
  }
  // function HandlePDF() {
  //   // window.print();
  //   var printwin = window.open("");
  //   printwin.document.write(document.getElementById("toprint").innerHTML);
  //   printwin.stop();
  //   printwin.print();
  //   printwin.close();
  // }

  // function SaveAsPDF() {
  //   if (UpdatedData) {
  //     setError(false);
  //     var doc = new jsPDF();
  //     var rows = [];

  //     let col = [
  //       "Sl.No",
  //       "Patient Name",
  //       "Modality",
  //       "Body Part",
  //       "Reported Time",
  //       "Day/Night",
  //       "Price",
  //     ];

  //     for (var key in UpdatedData) {
  //       var temp = [
  //         UpdatedData[key].id,
  //         UpdatedData[key].Name,
  //         UpdatedData[key].Modality,
  //         UpdatedData[key].BodyPart,
  //         UpdatedData[key].ReportedTime,
  //         UpdatedData[key].DayNight,
  //         UpdatedData[key].Price,
  //       ];
  //       // //console.log("iteration key:", key, "data:", data1[key]);
  //       rows.push(temp);
  //     }

  //     // autoTable(doc, { head: [col], body: [rows] });
  //     //console.log("Date:: ", new Date().toLocaleString().split(",")[0]);
  //     doc.autoTable(col, rows);
  //     doc.save(Doctors + "_invoice.pdf");
  //   } else {
  //     setError(true);
  //   }
  // }
  async function saveAsExcelClient() {
    if (UpdatedData) {
      let header = [
        "Sl.No",
        "Patient Name",
        "Doctor",
        "Modality",
        "Body Part",
        "No. of reports",
        "Dispatched Time",
        "Day/Night",
        "Price",
      ];

      XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const sheet1 = workbook.sheet(0);
        const sheetData = getSheetData(UpdatedData, header);
        const totalColumns = sheetData[0].length;

        sheet1.cell("A1").value(sheetData);
        sheet1.column("A").width(10);
        sheet1.column("B").width(25);
        sheet1.column("C").width(25);
        sheet1.column("D").width(25);
        sheet1.column("E").width(25);
        sheet1.column("F").width(25);
        sheet1.column("G").width(25);
        const range = sheet1.usedRange();
        const endColumn = String.fromCharCode(64 + totalColumns);
        sheet1.row(1).style("bold", true);
        sheet1.range("A1:" + endColumn + "1").style("fill", "d3d3d3");
        range.style("border", false);
        return workbook.outputAsync().then((res) => {
          saveAs(res, Clients + "_invoice.xlsx");
        });
      });
    }
  }

  //===================================

  const readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array", raw: true });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rawJson = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          defval: "",
        });

        const json = rawJson.flatMap((row) => {
          const doctors = getUniqueRows(
            String(getImportValue(row, "Doctor"))
              .split("|")
              .map((d) => d.trim())
              .filter(Boolean)
              .map((Doctor) => ({ Doctor })),
            (item) => normalizeWorklogValue(item.Doctor)
          ).map((item) => item.Doctor);

          const base = {
            Client: String(getImportValue(row, "Client")),
            Name: String(getImportValue(row, "Name")),
            Modality: String(getImportValue(row, "Modality")),
            ReportedTime: formatImportDateTime(
              getImportValue(row, "ReportedTime")
            ),
            DispatchedTime: formatImportDateTime(
              getImportValue(row, "DispatchedTime")
            ),
            BodyPart: String(getImportValue(row, "BodyPart")),
          };

          // Skip rows with no assigned doctor or not completed
          const status = String(getImportValue(row, "Status"))
            .trim()
            .toLowerCase();
          if (
            doctors.length === 0 ||
            status === "removed" ||
            status === "incoming"
          )
            return [];
          return doctors.map((doc) => ({ ...base, Doctor: doc }));
        });

        const uniqueJson = getUniqueRows(json, getStudyKey);

        setJsonDataToInsert(uniqueJson);
        //console.log("json:", json);
        // //console.log("JsonDataToInsert:", JsonDataToInsert);

        setDoctorsList(DistinctRecords(uniqueJson, "Doctor"));
        setClientsList(DistinctRecords(uniqueJson, "Client"));
        function DistinctRecords(MYJSON, prop) {
          return getUniqueRows(MYJSON, (obj) =>
            normalizeWorklogValue(obj[prop])
          );
        }
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };
  //console.log("Clients List: ", ClientsList);
  //console.log("Doctors List: ", DoctorsList);

  //console.log("Doctors:", Doctors);
  //console.log("Clients:", Clients);

  //console.log("FilteredData", FilteredData);

  useEffect(() => {
    if (Doctors != "") {
      setOpen(true);
      setFilteredData(
        JsonDataToInsert.filter((l) => {
          return (
            normalizeWorklogValue(l.Doctor) === normalizeWorklogValue(Doctors)
          );
        })
      );
    } else if (Clients != "") {
      setOpen(true);
      setFilteredData(
        JsonDataToInsert.filter((l) => {
          return (
            normalizeWorklogValue(l.Client) === normalizeWorklogValue(Clients)
          );
        })
      );
    } else {
      setOpen(false);
    }
  }, [Doctors, Clients, JsonDataToInsert]);
  function HandleBack() {
    setDocTotal(0);
    setTotal("");
    setInvoice("");
    setUpdatedData(false);
    setClient("");
    setDoctor("");
    setOpen(false);
    setInvoiceOpen(false);
  }

  const DoctorsData = DoctorsList.map((d) => ({
    Name: d.Doctor,
  }));
  console.log("DoctorsData:", DoctorsData);
  // //console.log("DoctorsTDSData:", DoctorsTDSData);
  const ClientsData = ClientsList.map((d) => ({
    Name: d.Client,
  }));
  console.log("ClientsData:", ClientsData);

  const FilteredData1 = FilteredData.map((d, key) => {
    const hour = getImportHour(d.ReportedTime);
    return {
      id: key + 1,
      Name: d.Name,
      Client: d.Client,
      Modality: d.Modality,
      BodyPart: d.BodyPart,
      ReportedTime: d.ReportedTime,
      DayNight: hour >= 7 && hour < 22 ? "Day" : hour >= 0 ? "Night" : "N/A",
      Price: "Not Generated",
    };
  });
  console.log("FilteredData1", FilteredData1);

  const FilteredData2 = FilteredData.map((d, key) => {
    const hour = getImportHour(d.DispatchedTime);
    return {
      id: key + 1,
      Name: d.Name,
      Doctor: d.Doctor,
      Modality: d.Modality,
      BodyPart: d.BodyPart,
      NoOfReport: d.BodyPart ? d.BodyPart.split(",").length : 1,
      DispatchedTime: d.DispatchedTime,
      DayNight: hour >= 8 && hour < 21 ? "Day" : hour >= 0 ? "Night" : "N/A",
      Price: "Not Generated",
    };
  });
  console.log("FilteredData2", FilteredData2);

  //Download as PDF
  // function printDocument() {
  //   const input = document.getElementById("toprint");
  //   html2canvas(input).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/JPEG");
  //     const pdf = new jsPDF();
  //     pdf.addImage(imgData, "JPEG", 0, 0);
  //     // pdf.output('dataurlnewwindow');
  //     pdf.save("download.pdf");
  //   });
  // }

  function HandleCansel() {
    setAddStaff(false);
    setClientsList([]);
    setDoctorsList([]);
    setJsonDataToInsert([]);
  }
  console.log("Error:", Error);
  console.log("DocTotal:::::", DocTotal);

  // const [DocPan, setDocPan] = useState(0);
  // const [TDSDataArray, setArray] = useState([]);
  // const [flag, setFlag] = useState(false);

  // useEffect(() => {
  //   //console.log("Inside USEEFFECT$$$$$$$$$$$$$");

  //   if (Doctors != "") {
  //     //console.log("Inside IF$$$$$$$$$$$$$");
  //     if (TDSDataArray.includes(DocPan)) {
  //       console.log("TDS added Already");
  //     } else {
  //       const DoctorsTDSData = {
  //         Name: Doctors,
  //         TotalAmount: DocTotal,
  //         TDS: parseFloat(DocTotal) * 0.1,
  //         Amount: DocTotal - parseFloat(DocTotal) * 0.1,
  //         Pan: DocPan,
  //         StringId: Doctors.replace(/ /g, "")
  //           .replace(/[^a-zA-Z0-9 ]/g, "")
  //           .toLowerCase(),
  //       };
  //       setArray((oldArray) => [...oldArray, DoctorsTDSData]);
  //     }
  //   }
  // }, [Doctors]);
  //console.log("DoctorsTDSDataAfter_Map:", TDSDataArray);

  function OpenInvoice() {
    setInvoiceOpen(true);
  }
  const [invoice, setInvoice] = useState({
    invoice_no: "",
    address: "",
    trans_date: "",
    due_date: "",
    balance: "",
    Discount: "",
    DelayCharges: "",
  });
  const actionButtonSx = {
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: 900,
    px: 2,
    py: 1,
    background: "#2f72f2",
    boxShadow: "0 8px 18px rgba(47,114,242,0.22)",
    "&:hover": { background: "#1d5fce" },
  };
  const ghostButtonSx = {
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: 800,
    px: 2,
    py: 1,
    borderColor: "#dce8fb",
    color: "#2f72f2",
  };
  const formatAmount = (value) => {
    const amount =
      Number.parseFloat(String(value ?? "").replace(/[^0-9.-]/g, "")) || 0;
    return amount.toFixed(2) + "/-";
  };
  const formatCurrency = (value) => {
    const amount =
      Number.parseFloat(String(value ?? "").replace(/[^0-9.-]/g, "")) || 0;
    return "Rs. " + amount.toFixed(2) + "/-";
  };
  const toInvoiceAmount = (value) =>
    Number.parseFloat(String(value ?? "").replace(/[^0-9.-]/g, "")) || 0;
  const invoiceSubtotal = toInvoiceAmount(Total);
  const previousBalance = toInvoiceAmount(invoice.balance);
  const delayCharges = toInvoiceAmount(invoice.DelayCharges);
  const discountAmount = toInvoiceAmount(invoice.Discount);
  const invoiceTotalDue =
    invoiceSubtotal + previousBalance + delayCharges - discountAmount;
  const reportRows = UpdatedData || FilteredData1 || [];
  const reportHeaders = [
    "Sl.No",
    "Name",
    "Client",
    "Modality",
    "Body Part",
    "Reported Time",
    "Day/Night",
    "Price",
  ];
  const printCellStyle = {
    border: "1px solid #cbd5e1",
    padding: "7px 9px",
    fontSize: 11,
    color: "#111827",
    verticalAlign: "top",
  };
  const printHeaderCellStyle = {
    ...printCellStyle,
    background: "#1f2937",
    color: "#ffffff",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.4,
  };
  const printLabelStyle = {
    color: "#475569",
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.3,
    marginBottom: 4,
  };
  const worklogHeaderCellStyle = {
    border: "1px solid #cbd5e1",
    padding: "8px 9px",
    fontSize: 10,
    fontWeight: 800,
    background: "#f8fafc",
    color: "#475569",
    textAlign: "left",
    textTransform: "uppercase",
  };
  const worklogCellStyle = {
    border: "1px solid #e2e8f0",
    padding: "8px 9px",
    fontSize: 10,
    color: "#111827",
    fontWeight: 600,
    verticalAlign: "top",
  };
  const doctorNetTotal =
    toInvoiceAmount(DocTotal) - toInvoiceAmount(DocTotal) * 0.1;
  const doctorTotalSummary = (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        mt: 2,
      }}
    >
      <Box
        sx={{
          minWidth: 280,
          maxWidth: "100%",
          border: "1px solid #e8eef7",
          borderRadius: "8px",
          overflow: "hidden",
          background: "#ffffff",
        }}
      >
        {[
          ["Total Earnings", formatAmount(DocTotal)],
          ["TDS(10%)", formatAmount(toInvoiceAmount(DocTotal) * 0.1)],
          ["Total amount", formatAmount(doctorNetTotal)],
        ].map(([label, value], index) => (
          <Box
            key={label}
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr auto",
              gap: 2,
              px: 2,
              py: 1,
              borderTop: index === 0 ? 0 : "1px solid #eef3f9",
              fontWeight: index === 2 ? 900 : 700,
              color: index === 2 ? "#0f172a" : "#334155",
            }}
          >
            <span>{label}</span>
            <span>{value}</span>
          </Box>
        ))}
      </Box>
    </Box>
  );
  //Function to handle Data input
  function HandleData(e) {
    const newData = { ...invoice };
    newData[e.target.id] = e.target.value;
    setInvoice(newData);
    console.log(newData);
  }
  // const [invoice, setInvoice] = useState("");
  // function HandleInvoice() {
  //   setInvoiceOpen(false);
  //   setInvoice({
  //     id: "invoice_001",
  //     invoice_no: data.invoice_no,
  //     balance: "",
  //     company: Clients,
  //     email: "",
  //     phone: "",
  //     address: data.address,
  //     trans_date: data.trans_date,
  //     due_date: data.due_date,
  //     items: [
  //       {
  //         sno: 1,
  //         desc: "Radiology Reporting CT & MRI cases",
  //         qty: FilteredData2.length,
  //         rate: Total,
  //       },
  //     ],
  //   });
  // }
  useEffect(() => {
    if (Doctors != "") {
      setLoaded(true);
    }
    if (Clients != "") {
      setLoadedClient(true);
    }
  }, [Doctors, Clients]);
  // useEffect(() => {
  //   console.log("inside TDS");
  //   if (DocTotal != 0) {
  //     console.log("inside TDS1");

  //     let formData = new FormData();
  //     formData.append("Id", 0);
  //     formData.append("DoctorName", Doctors);
  //     formData.append("Total", DocTotal);
  //     formData.append("TDS", DocTotal * 0.1);
  //     formData.append("Amount", DocTotal - DocTotal * 0.1);
  //     axios({
  //       method: "post",
  //       url: Domain + "/SaveTDS_data.php",
  //       data: formData,
  //       config: { headers: { "Content-Type": "multipart/form-data" } },
  //     })
  //       .then(function (response) {
  //         //handle success
  //         // //console.log("\n \t GetAllModalities:", response);
  //         if (response.data.success) {
  //           console.log("Success");
  //         }
  //       })
  //       .catch(function (response) {
  //         //handle error
  //         console.log(response);
  //       });
  //   }
  // }, [DocTotal]);
  return (
    <>
      <Snackbar
        place="bc"
        color="success"
        icon={AddAlert}
        message="WorkLog fetched successfully!"
        open={saved}
        closeNotification={() => setSaved(false)}
        close
      />
      <Snackbar
        place="bc"
        color="danger"
        icon={AddAlert}
        message="Error! Please try again"
        open={deleted}
        closeNotification={() => setDeleted(false)}
        close
      />
      {Open ? (
        <>
          {Doctors != "" ? (
            <>
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
                <MuiButton
                  variant="outlined"
                  startIcon={<ArrowLeft size={17} weight="bold" />}
                  onClick={HandleBack}
                  sx={ghostButtonSx}
                >
                  Back
                </MuiButton>
                <MuiButton
                  variant="contained"
                  startIcon={<DownloadSimple size={17} weight="bold" />}
                  onClick={saveAsExcel}
                  sx={actionButtonSx}
                >
                  Download Excel
                </MuiButton>
                {/* <Button onClick={SaveAsPDF} color="danger">
                Download PDF
              </Button> */}
                <ReactToPrint
                  trigger={() => (
                    <MuiButton
                      variant="outlined"
                      startIcon={<FilePdf size={17} weight="bold" />}
                      sx={ghostButtonSx}
                    >
                      Download PDF
                    </MuiButton>
                  )}
                  content={() => componentRef}
                />
              </Box>
              <div style={{ display: "none" }}>
                <div
                  ref={(el) => (componentRef = el)}
                  style={{
                    width: "210mm",
                    minHeight: "297mm",
                    padding: "12mm",
                    background: "#ffffff",
                    color: "#111827",
                    fontFamily: "Arial, Helvetica, sans-serif",
                    boxSizing: "border-box",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      borderBottom: "3px solid #1f2937",
                      marginBottom: 18,
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{
                            padding: "0 0 16px 0",
                            width: "48%",
                          }}
                        >
                          <div
                            style={{
                              width: 365,
                              height: 82,
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={LogoHeader}
                              alt="Telemed Healthcare Solutions"
                              style={{
                                width: 376,
                                marginLeft: -2,
                                marginTop: -2,
                              }}
                            />
                          </div>
                        </td>
                        <td
                          style={{
                            padding: "0 0 16px 12px",
                            textAlign: "right",
                            verticalAlign: "middle",
                          }}
                        >
                          <div
                            style={{
                              color: "#475569",
                              fontSize: 11,
                              fontWeight: 800,
                              letterSpacing: 0.4,
                              textTransform: "uppercase",
                              marginBottom: 8,
                            }}
                          >
                            Worklog Report
                          </div>
                          <div
                            style={{
                              color: "#111827",
                              fontSize: 18,
                              fontWeight: 800,
                              marginBottom: 6,
                            }}
                          >
                            {Doctors}
                          </div>
                          <div
                            style={{
                              display: "inline-block",
                              background: "#f8fafc",
                              borderLeft: "4px solid #1f2937",
                              padding: "8px 12px",
                              fontSize: 12,
                              fontWeight: 800,
                            }}
                          >
                            Total Number of Cases: {reportRows.length}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div
                    style={{
                      textAlign: "right",
                      color: "#111827",
                      fontSize: 12,
                      fontWeight: 800,
                      letterSpacing: 0,
                      marginBottom: 22,
                    }}
                  >
                    TOTAL EARNINGS {formatCurrency(DocTotal)} &nbsp; || &nbsp;
                    TDS (10%) {formatCurrency(toInvoiceAmount(DocTotal) * 0.1)}
                    &nbsp; || &nbsp; TOTAL AMOUNT{" "}
                    {formatCurrency(doctorNetTotal)}
                  </div>

                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead>
                      <tr>
                        {reportHeaders.map((head, index) => (
                          <th
                            key={head}
                            style={{
                              ...worklogHeaderCellStyle,
                              width:
                                index === 0
                                  ? 48
                                  : index === 1
                                  ? "24%"
                                  : index === 3
                                  ? "21%"
                                  : "auto",
                            }}
                          >
                            {head}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {reportRows.map((row, rowIndex) => (
                        <tr key={row.Id || row.Name || rowIndex}>
                          {Object.values(row).map((value, cellIndex) => (
                            <td
                              key={`${rowIndex}-${cellIndex}`}
                              style={{
                                ...worklogCellStyle,
                                textAlign:
                                  cellIndex === 0 || cellIndex === 6
                                    ? "right"
                                    : "left",
                              }}
                            >
                              {value}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <Card>
                <Box
                  sx={{
                    px: 2.5,
                    py: 1.75,
                    borderBottom: "1px solid #e8eef7",
                    background: "#ffffff",
                  }}
                >
                  <Typography
                    sx={{ fontSize: 20, fontWeight: 900, color: "#162033" }}
                  >
                    Doctor - {Doctors}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#64748b", mt: 0.3 }}>
                    Total Number of Cases: {FilteredData1.length}
                  </Typography>
                </Box>
                <Events
                  data={FilteredData1}
                  Entity={Doctors}
                  setData={setUpdatedData}
                  loaded={loaded}
                  setTotal={setDocTotal}
                />
                <CardBody>
                  {UpdatedData ? (
                    <>
                      <Table
                        tableHeaderColor="info"
                        tableHead={[
                          "Sl.No",
                          "Name",
                          "Client",
                          "Modality",
                          "Body Part",
                          "Reported Time",
                          "Day/Night",
                          "Price",
                        ]}
                        tableData={UpdatedData}
                        loading={false}
                        noAction={true}
                        disablePagination={true}
                      />
                      <br />
                      {doctorTotalSummary}
                    </>
                  ) : (
                    <>
                      <Table
                        tableHeaderColor="info"
                        tableHead={[
                          "Sl.No",
                          "Name",
                          "Client",
                          "Modality",
                          "Body Part",
                          "Reported Time",
                          "Day/Night",
                          "Price",
                        ]}
                        tableData={FilteredData1}
                        loading={false}
                        noAction={true}
                        disablePagination={true}
                      />
                    </>
                  )}
                </CardBody>
              </Card>
            </>
          ) : (
            <> </>
          )}
          {Clients != "" ? (
            <>
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
                <MuiButton
                  variant="outlined"
                  startIcon={<ArrowLeft size={17} weight="bold" />}
                  onClick={HandleBack}
                  sx={ghostButtonSx}
                >
                  Back
                </MuiButton>
                <MuiButton
                  variant="contained"
                  startIcon={<DownloadSimple size={17} weight="bold" />}
                  onClick={saveAsExcelClient}
                  sx={actionButtonSx}
                >
                  Download Excel
                </MuiButton>
                <MuiButton
                  variant="outlined"
                  startIcon={<Receipt size={17} weight="bold" />}
                  onClick={OpenInvoice}
                  sx={ghostButtonSx}
                >
                  Generate Invoice
                </MuiButton>
              </Box>
              {InvoiceOpen ? (
                <>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        onChange={(e) => HandleData(e)}
                        value={invoice.invoice_no}
                        labelText="Invoice Number"
                        id="invoice_no"
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        onChange={(e) => HandleData(e)}
                        value={invoice.trans_date}
                        labelText="Invoice Date (dd/mm/yyyy To dd/mm/yyy)"
                        id="trans_date"
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        onChange={(e) => HandleData(e)}
                        value={invoice.due_date}
                        labelText="Due Date"
                        id="due_date"
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        onChange={(e) => HandleData(e)}
                        value={invoice.address}
                        labelText="Client Address (Optional)"
                        id="address"
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        onChange={(e) => HandleData(e)}
                        value={invoice.balance}
                        labelText="Previous Balance"
                        id="balance"
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        onChange={(e) => HandleData(e)}
                        value={invoice.DelayCharges}
                        labelText="Delay Charges"
                        id="DelayCharges"
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        onChange={(e) => HandleData(e)}
                        value={invoice.Discount}
                        labelText="Discount"
                        id="Discount"
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <ReactToPrint
                    trigger={() => (
                      <Button color="danger">Download Invoice</Button>
                    )}
                    content={() => componentRef2}
                  />
                  <div style={{ display: "none" }}>
                    <div
                      ref={(el) => (componentRef2 = el)}
                      style={{
                        width: "210mm",
                        minHeight: "297mm",
                        padding: "9mm",
                        background: "#ffffff",
                        color: "#111827",
                        fontFamily: "Arial, Helvetica, sans-serif",
                        boxSizing: "border-box",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginBottom: 22,
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                              style={{
                                borderBottom: "3px solid #1f2937",
                                paddingBottom: 12,
                                width: "48%",
                              }}
                            >
                              <div
                                style={{
                                  width: 355,
                                  height: 80,
                                  overflow: "hidden",
                                }}
                              >
                                <img
                                  src={LogoHeader}
                                  alt="Telemed Healthcare Solutions"
                                  style={{
                                    width: 365,
                                    marginLeft: -2,
                                    marginTop: -2,
                                  }}
                                />
                              </div>
                            </td>
                            <td
                              style={{
                                borderBottom: "3px solid #1f2937",
                                paddingBottom: 12,
                                textAlign: "right",
                                verticalAlign: "top",
                                fontSize: 10,
                                color: "#111827",
                                lineHeight: 1.45,
                                fontWeight: 700,
                              }}
                            >
                              INTHC Solutions Private Limited
                              <br />
                              C/o Gokul Raj, Mulamoottilvaliyil
                              <br />
                              Managanam, Pandalam
                              <br />
                              Kerala 689501
                              <br />
                              PAN: AAGCI4276F
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginBottom: 18,
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: "48%",
                                verticalAlign: "top",
                                padding: 0,
                              }}
                            >
                              <div
                                style={{
                                  fontSize: 28,
                                  fontWeight: 800,
                                  letterSpacing: 1,
                                  textTransform: "uppercase",
                                }}
                              >
                                Invoice
                              </div>
                              <div
                                style={{
                                  color: "#64748b",
                                  fontSize: 12,
                                  marginTop: 4,
                                }}
                              >
                                Radiology Reporting Services
                              </div>
                            </td>
                            <td
                              style={{
                                padding: 0,
                                textAlign: "right",
                                verticalAlign: "top",
                              }}
                            >
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "#111827",
                                  fontSize: 12,
                                  lineHeight: 1.65,
                                  fontWeight: 700,
                                  minWidth: 260,
                                }}
                              >
                                <div>
                                  Invoice No.: {invoice.invoice_no || "-"}
                                </div>
                                <div>
                                  Invoice Date: {new Date().toDateString()}
                                </div>
                                <div>
                                  Bill Period: {invoice.trans_date || "-"}
                                </div>
                                <div>Due Date: {invoice.due_date || "-"}</div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginBottom: 18,
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                              style={{
                                ...printCellStyle,
                                width: "50%",
                                minHeight: 92,
                              }}
                            >
                              <div style={printLabelStyle}>Bill To</div>
                              <div style={{ fontSize: 15, fontWeight: 800 }}>
                                {Clients || "-"}
                              </div>
                              <div
                                style={{
                                  color: "#334155",
                                  fontSize: 12,
                                  lineHeight: 1.6,
                                  marginTop: 8,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                {invoice.address || "Address not provided"}
                              </div>
                            </td>
                            <td
                              style={{
                                ...printCellStyle,
                                width: "50%",
                                minHeight: 92,
                              }}
                            >
                              <div style={printLabelStyle}>From</div>
                              <div style={{ fontSize: 15, fontWeight: 800 }}>
                                INTHC Solutions Private Limited
                              </div>
                              <div
                                style={{
                                  color: "#334155",
                                  fontSize: 12,
                                  lineHeight: 1.6,
                                  marginTop: 8,
                                }}
                              >
                                Telemed Healthcare Solutions
                                <br />
                                Phone: +91 7994712111
                                <br />
                                Email: Telemedhealthcaresolutions@gmail.com
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginBottom: 28,
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={{ ...printHeaderCellStyle, width: 60 }}>
                              S.No
                            </th>
                            <th style={{ ...printHeaderCellStyle }}>
                              Particulars
                            </th>
                            <th
                              style={{
                                ...printHeaderCellStyle,
                                width: 90,
                                textAlign: "right",
                              }}
                            >
                              Qty
                            </th>
                            <th
                              style={{
                                ...printHeaderCellStyle,
                                width: 150,
                                textAlign: "right",
                              }}
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{ ...printCellStyle, textAlign: "center" }}
                            >
                              1
                            </td>
                            <td style={printCellStyle}>
                              Radiology Reporting X-ray, CT & MRI cases
                            </td>
                            <td
                              style={{ ...printCellStyle, textAlign: "right" }}
                            >
                              {FilteredData2.length}
                            </td>
                            <td
                              style={{ ...printCellStyle, textAlign: "right" }}
                            >
                              {formatCurrency(invoiceSubtotal)}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginBottom: 18,
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                              style={{
                                ...printCellStyle,
                                width: "54%",
                                background: "#f8fafc",
                                lineHeight: 1.6,
                              }}
                            >
                              <div
                                style={{
                                  background: "#1f2937",
                                  color: "#ffffff",
                                  padding: "8px 10px",
                                  margin: "-7px -9px 8px -9px",
                                  fontSize: 12,
                                  fontWeight: 800,
                                  textTransform: "uppercase",
                                  letterSpacing: 0.4,
                                }}
                              >
                                Make Payments To
                              </div>
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                }}
                              >
                                <tbody>
                                  {[
                                    [
                                      "Beneficiary Name",
                                      "INTHC Solutions Private Limited",
                                    ],
                                    ["A/C Number", "50200114588231"],
                                    ["IFSC Code", "HDFC0001504"],
                                    ["PAN Number", "AAGCI4276F"],
                                    ["Bank Branch", "Pandalam"],
                                  ].map(([label, value]) => (
                                    <tr key={label}>
                                      <td
                                        style={{
                                          padding: "5px 0",
                                          width: 150,
                                          color: "#475569",
                                          fontWeight: 800,
                                          borderBottom: "1px solid #e2e8f0",
                                        }}
                                      >
                                        {label}
                                      </td>
                                      <td
                                        style={{
                                          padding: "5px 0",
                                          borderBottom: "1px solid #e2e8f0",
                                          fontWeight: 700,
                                        }}
                                      >
                                        {value}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                            <td
                              style={{
                                padding: "0 0 0 12px",
                                verticalAlign: "top",
                              }}
                            >
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                }}
                              >
                                <tbody>
                                  {[
                                    ["Sub Total", invoiceSubtotal],
                                    ["Previous Balance", previousBalance],
                                    ["Delay Charges", delayCharges],
                                    ["Discount", -discountAmount],
                                  ].map(([label, value]) => (
                                    <tr key={label}>
                                      <td style={printCellStyle}>{label}</td>
                                      <td
                                        style={{
                                          ...printCellStyle,
                                          textAlign: "right",
                                          fontWeight: 700,
                                        }}
                                      >
                                        {formatCurrency(value)}
                                      </td>
                                    </tr>
                                  ))}
                                  <tr>
                                    <td
                                      style={{
                                        ...printHeaderCellStyle,
                                        fontSize: 13,
                                      }}
                                    >
                                      Total Due
                                    </td>
                                    <td
                                      style={{
                                        ...printHeaderCellStyle,
                                        fontSize: 13,
                                        textAlign: "right",
                                      }}
                                    >
                                      {formatCurrency(invoiceTotalDue)}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div
                        style={{
                          paddingTop: 8,
                        }}
                      >
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            borderTop: "1px solid #cbd5e1",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  ...printCellStyle,
                                  width: "62%",
                                  lineHeight: 1.7,
                                }}
                              >
                                <div style={printLabelStyle}>Notes</div>
                                For any discrepancy please contact INTHC
                                Solutions Private Limited.
                                <br />
                                Email: Telemedhealthcaresolutions@gmail.com
                                <br />
                                Phone: +91 7994712111
                                <br />
                                Website: www.Telemedhealthcaresolutions.com
                              </td>
                              <td
                                style={{
                                  ...printCellStyle,
                                  textAlign: "center",
                                  verticalAlign: "bottom",
                                }}
                              >
                                <img
                                  width="170"
                                  src={Signature}
                                  alt="Authorized signature"
                                />
                                <div
                                  style={{
                                    borderTop: "1px solid #111827",
                                    paddingTop: 8,
                                    marginTop: 6,
                                    fontSize: 12,
                                    fontWeight: 700,
                                  }}
                                >
                                  Authorized Signatory
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: 18,
                          marginBottom: 22,
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid #cbd5e1",
                            padding: 14,
                            minHeight: 92,
                          }}
                        >
                          <div style={printLabelStyle}>Bill To</div>
                          <div style={{ fontSize: 15, fontWeight: 800 }}>
                            {Clients || "-"}
                          </div>
                          <div
                            style={{
                              color: "#334155",
                              fontSize: 12,
                              lineHeight: 1.6,
                              marginTop: 8,
                              whiteSpace: "pre-line",
                            }}
                          >
                            {invoice.address || "Address not provided"}
                          </div>
                        </div>
                        <div
                          style={{
                            border: "1px solid #cbd5e1",
                            padding: 14,
                            minHeight: 92,
                          }}
                        >
                          <div style={printLabelStyle}>From</div>
                          <div style={{ fontSize: 15, fontWeight: 800 }}>
                            INTHC Solutions Private Limited
                          </div>
                          <div
                            style={{
                              color: "#334155",
                              fontSize: 12,
                              lineHeight: 1.6,
                              marginTop: 8,
                            }}
                          >
                            Telemed Healthcare Solutions
                            <br />
                            Phone: +91 7994712111
                            <br />
                            Email: Telemedhealthcaresolutions@gmail.com
                          </div>
                        </div>
                      </div>

                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginBottom: 18,
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={{ ...printHeaderCellStyle, width: 60 }}>
                              S.No
                            </th>
                            <th style={{ ...printHeaderCellStyle }}>
                              Particulars
                            </th>
                            <th
                              style={{
                                ...printHeaderCellStyle,
                                width: 90,
                                textAlign: "right",
                              }}
                            >
                              Qty
                            </th>
                            <th
                              style={{
                                ...printHeaderCellStyle,
                                width: 150,
                                textAlign: "right",
                              }}
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{ ...printCellStyle, textAlign: "center" }}
                            >
                              1
                            </td>
                            <td style={printCellStyle}>
                              Radiology Reporting X-ray, CT & MRI cases
                            </td>
                            <td
                              style={{ ...printCellStyle, textAlign: "right" }}
                            >
                              {FilteredData2.length}
                            </td>
                            <td
                              style={{ ...printCellStyle, textAlign: "right" }}
                            >
                              {formatCurrency(invoiceSubtotal)}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 300px",
                          gap: 18,
                          alignItems: "start",
                          marginBottom: 24,
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid #cbd5e1",
                            background: "#f8fafc",
                            padding: 14,
                            fontSize: 12,
                            color: "#334155",
                            lineHeight: 1.6,
                          }}
                        >
                          <div style={printLabelStyle}>Notes</div>
                          Please review the invoice details and notify INTHC
                          Solutions Private Limited immediately in case of any
                          discrepancy.
                        </div>
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                          }}
                        >
                          <tbody>
                            {[
                              ["Sub Total", invoiceSubtotal],
                              ["Previous Balance", previousBalance],
                              ["Delay Charges", delayCharges],
                              ["Discount", -discountAmount],
                            ].map(([label, value]) => (
                              <tr key={label}>
                                <td style={printCellStyle}>{label}</td>
                                <td
                                  style={{
                                    ...printCellStyle,
                                    textAlign: "right",
                                    fontWeight: 700,
                                  }}
                                >
                                  {formatCurrency(value)}
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <td
                                style={{
                                  ...printHeaderCellStyle,
                                  fontSize: 13,
                                }}
                              >
                                Total Due
                              </td>
                              <td
                                style={{
                                  ...printHeaderCellStyle,
                                  fontSize: 13,
                                  textAlign: "right",
                                }}
                              >
                                {formatCurrency(invoiceTotalDue)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 220px",
                          gap: 24,
                          alignItems: "end",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid #cbd5e1",
                          }}
                        >
                          <div
                            style={{
                              background: "#1f2937",
                              color: "#ffffff",
                              padding: "9px 12px",
                              fontSize: 12,
                              fontWeight: 800,
                              textTransform: "uppercase",
                              letterSpacing: 0.4,
                            }}
                          >
                            Make Payments To
                          </div>
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                            }}
                          >
                            <tbody>
                              {[
                                [
                                  "Beneficiary Name",
                                  "INTHC Solutions Private Limited",
                                ],
                                ["A/C Number", "50200114588231"],
                                ["IFSC Code", "HDFC0001504"],
                                ["PAN Number", "AAGCI4276F"],
                                ["Bank Branch", "Pandalam"],
                              ].map(([label, value]) => (
                                <tr key={label}>
                                  <td
                                    style={{
                                      ...printCellStyle,
                                      width: 170,
                                      background: "#f8fafc",
                                      fontWeight: 700,
                                    }}
                                  >
                                    {label}
                                  </td>
                                  <td style={printCellStyle}>{value}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <img
                            width="180"
                            src={Signature}
                            alt="Authorized signature"
                          />
                          <div
                            style={{
                              borderTop: "1px solid #111827",
                              paddingTop: 8,
                              marginTop: 6,
                              fontSize: 12,
                              fontWeight: 700,
                            }}
                          >
                            Authorized Signatory
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          borderTop: "1px solid #cbd5e1",
                          marginTop: 26,
                          paddingTop: 10,
                          textAlign: "center",
                          color: "#475569",
                          fontSize: 11,
                          lineHeight: 1.5,
                        }}
                      >
                        For any discrepancy please contact INTHC Solutions
                        Private Limited. Email:
                        Telemedhealthcaresolutions@gmail.com | Phone: +91
                        7994712111 | Website: www.Telemedhealthcaresolutions.com
                      </div>
                      */}
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              {/* {invoice != "" ? (
                <>
                  {" "}
                  <PDFViewer width="100%" height="600" className="app">
                    <Invoice invoice={invoice} />
                  </PDFViewer>
                </>
              ) : (
                <></>
              )} */}
              <Card>
                <Box
                  sx={{
                    px: 2.5,
                    py: 1.75,
                    borderBottom: "1px solid #e8eef7",
                    background: "#ffffff",
                  }}
                >
                  <Typography
                    sx={{ fontSize: 20, fontWeight: 900, color: "#162033" }}
                  >
                    Client - {Clients}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#64748b", mt: 0.3 }}>
                    Total Number of Cases: {FilteredData2.length} | Total
                    Amount: {formatCurrency(Total)}
                  </Typography>
                </Box>
                <Events1
                  data={FilteredData2}
                  Entity={Clients}
                  setData={setUpdatedData}
                  setTotal={setTotal}
                  loaded={Clientloaded}
                />
                <CardBody>
                  {UpdatedData ? (
                    <>
                      <Table
                        tableHeaderColor="info"
                        tableHead={[
                          "Sl.No",
                          "Name",
                          "Doctor",
                          "Modality",
                          "Body Part",
                          "No. Of report",
                          "Dispatched Time",
                          "Day/Night",
                          "Price",
                        ]}
                        tableData={UpdatedData}
                        loading={false}
                        noAction={true}
                        disablePagination={true}
                      />
                    </>
                  ) : (
                    <>
                      <Table
                        tableHeaderColor="info"
                        tableHead={[
                          "Sl.No",
                          "Name",
                          "Doctor",
                          "Modality",
                          "Body Part",
                          "No. Of report",
                          "Dispatched Time",
                          "Day/Night",
                          "Price",
                        ]}
                        tableData={FilteredData2}
                        loading={false}
                        noAction={true}
                        disablePagination={true}
                      />
                    </>
                  )}
                </CardBody>
              </Card>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 2,
              mb: 2.5,
            }}
          >
            <Box>
              <Typography
                sx={{ fontSize: 28, fontWeight: 900, color: "#162033" }}
              >
                Billing Workspace
              </Typography>
              <Typography sx={{ fontSize: 14, color: "#64748b", mt: 0.6 }}>
                Upload worklogs and generate doctor or client billing reports.
              </Typography>
            </Box>
            <MuiButton
              variant="contained"
              startIcon={<UploadSimple size={18} weight="bold" />}
              onClick={() => setAddStaff(true)}
              sx={actionButtonSx}
            >
              Upload Excel
            </MuiButton>
          </Box>
          {AddStaff ? (
            <Paper
              elevation={0}
              sx={{
                borderRadius: "8px",
                border: "1px solid #e8eef7",
                boxShadow: "0 14px 34px rgba(15,23,42,0.06)",
                p: 2.5,
                mb: 2.5,
                background: "#ffffff",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  flexWrap: "wrap",
                  mb: 2,
                }}
              >
                <Box>
                  <Typography
                    sx={{ fontSize: 18, fontWeight: 900, color: "#162033" }}
                  >
                    Upload Excel
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#64748b", mt: 0.3 }}>
                    Select the worklog file from your system.
                  </Typography>
                </Box>
                <MuiButton
                  variant="outlined"
                  onClick={HandleCansel}
                  sx={ghostButtonSx}
                >
                  Cancel
                </MuiButton>
              </Box>
              <Box
                sx={{
                  border: "1px dashed #bfd4f6",
                  background: "#f8fbff",
                  borderRadius: "8px",
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  flexWrap: "wrap",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Box
                    sx={{
                      width: 42,
                      height: 42,
                      borderRadius: "8px",
                      display: "grid",
                      placeItems: "center",
                      background: "#e8f0fe",
                      color: "#2f72f2",
                    }}
                  >
                    <UploadSimple size={22} weight="duotone" />
                  </Box>
                  <Box>
                    <Typography
                      sx={{ fontSize: 14, fontWeight: 800, color: "#162033" }}
                    >
                      Worklog spreadsheet
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                      Excel files are parsed into doctors, clients and report
                      totals.
                    </Typography>
                  </Box>
                </Box>
                <input
                  type="file"
                  name="upload"
                  id="upload"
                  onChange={readUploadFile}
                  style={{
                    border: "1px solid #dce8fb",
                    borderRadius: "8px",
                    padding: "10px",
                    background: "#ffffff",
                  }}
                />
              </Box>
            </Paper>
          ) : (
            <></>
          )}
          <GridContainer>
            <GridItem xs={6} sm={6} md={6}>
              <Paper
                elevation={0}
                sx={{
                  borderRadius: "8px",
                  border: "1px solid #e8eef7",
                  boxShadow: "0 14px 34px rgba(15,23,42,0.06)",
                  overflow: "hidden",
                  background: "#ffffff",
                }}
              >
                <Box
                  sx={{
                    px: 2.5,
                    py: 1.5,
                    borderBottom: "1px solid #e8eef7",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.25,
                  }}
                >
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: "8px",
                      display: "grid",
                      placeItems: "center",
                      background: "#e8f0fe",
                      color: "#2f72f2",
                    }}
                  >
                    <Receipt size={18} weight="duotone" />
                  </Box>
                  <Box>
                    <Typography
                      sx={{ fontSize: 16, fontWeight: 900, color: "#162033" }}
                    >
                      Doctors List
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>
                      {DoctorsData.length} billing profiles
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ p: 1.5 }}>
                  <Table
                    tableHeaderColor="info"
                    tableHead={["Name", "Action"]}
                    tableData={DoctorsData}
                    loading={false}
                    noAction={false}
                    setEdit={setDoctor}
                  />
                </Box>
              </Paper>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <Paper
                elevation={0}
                sx={{
                  borderRadius: "8px",
                  border: "1px solid #e8eef7",
                  boxShadow: "0 14px 34px rgba(15,23,42,0.06)",
                  overflow: "hidden",
                  background: "#ffffff",
                }}
              >
                <Box
                  sx={{
                    px: 2.5,
                    py: 1.5,
                    borderBottom: "1px solid #e8eef7",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.25,
                  }}
                >
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: "8px",
                      display: "grid",
                      placeItems: "center",
                      background: "#ecfdf3",
                      color: "#16833a",
                    }}
                  >
                    <UsersThree size={18} weight="duotone" />
                  </Box>
                  <Box>
                    <Typography
                      sx={{ fontSize: 16, fontWeight: 900, color: "#162033" }}
                    >
                      Clients List
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>
                      {ClientsData.length} billing profiles
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ p: 1.5 }}>
                  <Table
                    tableHeaderColor="info"
                    tableHead={["Name", "Action"]}
                    tableData={ClientsData}
                    loading={false}
                    noAction={false}
                    setEdit={setClient}
                  />
                </Box>
              </Paper>
            </GridItem>
          </GridContainer>
          {/* Temporarily disabled: Doctors TDS Data card. */}
          {/*
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Paper
                elevation={0}
                sx={{
                  borderRadius: "8px",
                  border: "1px solid #e8eef7",
                  boxShadow: "0 14px 34px rgba(15,23,42,0.06)",
                  background: "#ffffff",
                  mt: 1,
                  p: 2,
                }}
              >
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 900,
                    color: "#162033",
                    mb: 1,
                  }}
                >
                  Doctors TDS Data
                </Typography>
                <Events2 JsonData={JsonDataToInsert} Doctors={DoctorsData} />
              </Paper>
            </GridItem>
          </GridContainer>
          */}
        </>
      )}
    </>
  );
}
